<template>
  <div class="home-container-wrap">
    <div class="draw-container" :style="{ backgroundImage: 'url('+backgroudPicture+')', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', }">
      <div class="luck_draw_box">
        <LuckDraw :prizeList="prizeList" :jointlimit="jointLimit" :modifiedtime="modifiedTime" :lotteryId="lotteryId" :status="status" @endDraw="endDraw"></LuckDraw>
      </div>
      <!-- <span>{{adNum}}</span> -->
      <div class="adLook" v-if='adNum > 0'>
        <p v-if='drawCount != 3'>观看视频可免费获得一次抽奖机会</p>
        <p v-else>今日3次看视频增加抽奖机会已用完</p>
        <button v-if='drawCount != 3' @click="addLottery">点击观看</button>
      </div>
      <!-- 中奖名单 -->
      <winlist :winList="winList"></winlist>
      <!-- 活动规则 -->
      <rule :ruleDes="ruleDes"></rule>
      <!-- <img class="decoration3" src="../assets/images/decoration3.png" alt=""> -->
    </div>
  </div>
</template>

<script>
import api from '@/api/pmall';
import { mapGetters } from 'vuex';
import LuckDraw from '../components/LuckDraw/LuckDraw';
import winlist from '../components/winList/winList';
import rule from '../components/rule/rule';

export default {
  name: 'Draw',
  components: {
    LuckDraw,
    winlist,
    rule,
  },
  data() {
    return {
      status: 'active', // 活动状态active：进行中
      winList: [], // 中奖名单
      prizeList: [], // 奖品列表
      jointLimit: 0, // 剩余多少次抽奖机会
      modifiedTime: '', // 活动更新时间
      ruleDes: '', // 活动规则
      // lotteryId: '', // 活动ID
      lotteryName: '', // 活动名称
      backgroudPicture: '#fff',
      adNum: 0,
      drawCount: 0,
      // drawCount: 0,
    };
  },
  computed: {
    ...mapGetters(['mobile', 'backgroud', 'rule', 'title']),
  },
  mounted() {
    this.backgroudPicture = this.backgroud;
    document.title = this.title;
    const value = JSON.parse(localStorage.getItem('activityInfo'));
    console.log(value);
    if (value && Number.isInteger(value.adNum)) {
      this.adNum = value.adNum;
      this.token = value.token;
      this.lotteryId = value.lotteryId;
      console.log('adNum:', this.adNum);
    }
    this.init();
  },
  methods: {

    // 抽奖机会加1
    addLottery() {
      wx.miniProgram.navigateTo({
        url: `/pages/advertisement/advertisement?id=${this.lotteryId}`,
      });
    },
    test() {
      // const data = {
      //   token: this.token,
      //   lottery_id: this.lotteryId,
      //   brand_code: 2,
      //   lottery_joint_num: 1,
      //   action_type: 'repeat',
      //   method: 'activityExchangeNumAdaptation',
      // };
      // api.addLottery1(data).then((res) => {
      //   if (res.status === 'fail') {
      //     this.$toast(res.msg);
      //     return;
      //   }
      //   const resData = res.data;
      //   this.jointLimit = resData.lottery_joint_limit;
      // });
    },
    // 修改显示抽奖次数
    endDraw(data) {
      window.gio('track', 'activitypage_buttonclick', {
        pagename_var: '抽奖页',
        pitname_var: '立即抽奖',
        activityname_var: this.title,
      });
      this.jointLimit = data.lottery_joint_limit;
      this.init('noFrist');
    },

    // 获取抽奖奖品 及 中奖列表
    init(e) {
      console.log('init--------');
      const data = {
        token: this.token,
        lottery_id: this.lotteryId,
        brand_code: 2,
        method: 'getLottery',
      };
      api.getLotteryInfo(data).then((res) => {
        if (res.status === 'fail') {
          this.$toast(res.msg);
          return;
        }
        const resData = res.data;
        const { lottery_rules, lottery_result } = resData;
        if (!lottery_rules) {
          return false;
        }
        lottery_rules && lottery_rules.splice(4, 0, 'true');
        this.prizeList = lottery_rules;
        if (e === 'noFrist') {
          this.winList = lottery_result;
        } else {
          this.winList = lottery_result;
          this.jointLimit = resData.lottery_joint_limit;
          this.status = resData.status;
          this.modifiedTime = resData.modified_time;
          this.lotteryName = resData.lottery_name;
          this.ruleDes = resData.lottery_desc;
          this.drawCount = resData.activity_today_joint_limit;
          window.gio('page.set', {
            pagemodule_pvar: '活动',
            pagetype_pvar: '活动详情页',
            activityname_pvar: this.lotteryName,
          });
        }
      });
    },
  },
};
/* eslint-disable */
</script>

 <style lang="stylus" scoped>
 .home-container-wrap{
  width 100vw
  height 100%
  background: url('../assets/images/home_bg.png') no-repeat top center;
  background-size: cover;
}
  // 刘海屏
  @media only screen and (device-width : 414px) and (device-height : 896px) and (-webkit-device-pixel-ratio : 2) {
    // .draw-container{
    //   padding-top:20px;
    // }
  }
  @media only screen and (device-width : 375px) and (device-height : 812px) and (-webkit-device-pixel-ratio : 3) {
    .draw-container{
      padding-top:20px;
    }
  }
  @media only screen and (device-width : 414px) and (device-height : 896px) and (-webkit-device-pixel-ratio : 3) {
    // .draw-container{
    //   padding-top:20px;
    // }
  }
  @media only screen and (device-width : 392px) and (device-height : 800px) and (-webkit-device-pixel-ratio : 3) {
    // 戴建 手机
    .draw-container{
      padding-top:20px;
    }
  }
  @media only screen and (device-width : 360px) and (device-height : 780px) and (-webkit-device-pixel-ratio : 3) {
    .draw-container{
      padding-top:40px;
    }
  }

</style>
<style lang='stylus'>
.draw-container{
  width:375px;
  min-height: 100%;
  overflow-x:hidden;
  position: relative;
  .luck_draw_box {
    margin: 30px auto 0;
    width: 341px;
    height: 398px;
    padding:25px 0px 0 10px;
    box-sizing: border-box;
  }
  .decoration3{
    width 22px
    height 32px
    position absolute
    top: 425px
    right 75px
  }
  .adLook{
    margin-top -12px
    text-align center
    background-image: url('../assets/images/decoration3.png');
    background-repeat no-repeat
    background-position 270px 5px
    background-size 22px 32px;
    // width 22px
    // height 32px

    p {
      font-size: 14px;
      color: #FFFFFF;
      text-align: center;
      font-weight bold;
    }
    button{
      margin-top 20px
      width 271px
      height 48px
      background-image: linear-gradient(270deg, #FF6D0E 0%, #FFA469 100%);
      border-radius: 24px;
      font-size: 16px;
      color: #FFFFFF;
      font-weight bold;
    }
  }
}

</style>

